import { API_URL, ID_TOKEN_KEY } from "@/common/config";
import apiService, { extend } from "@dg/request";
import { getWithExpiry } from "@dg/utils";
import { message } from "ant-design-vue";
import { destroyToken } from "@dg/utils";
message.config({
  maxCount: 1,
});

apiService.extend({
  prefix: API_URL,
  errorHandler: (error) => {
    if (error.data.code === 401) {
      destroyToken(ID_TOKEN_KEY);
      localStorage.removeItem("userType");
    }
    if (error.response) {
      const { message: text } = error.data;
      message.error(text);
    }
  },
});

const newRequest = extend({});
// 长时间连续操作 自动刷新token
apiService.request.use(async (ctx, next) => {
  const {
    req: {
      options: { prefix, headers },
    },
  } = ctx;
  const token = getWithExpiry(ID_TOKEN_KEY);
  // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiZXhwIjoxNjY2MTg1MDc1LCJsb2dpbl9uYW1lIjoiYWRtaW4iLCJvcmlnX2lhdCI6MTY2NjE2NzA3NX0.vSFZmmpCfi5lpvDkVwmC2_PhylOjNsEwY4HiNShq-Dw";
  if (token) {
    ctx.req.options.headers = {
      Authorization: `jwt ${token.value}`,
      ...headers,
    };
  }

  await next();
});

// 请求数据处理
apiService.request.use(async (ctx, next) => {
  await next();
  let { res } = ctx;
  const { code, data } = res; // 假设返回结果为 : { success: false, errorCode: 'B001' }
  if (code >= 200 && code < 300) {
    ctx.res = {
      success: true,
      data,
      msg: "",
    };
    // 对异常情况做对应处理
  }
});
export default apiService;
